import { useBreakoutUser } from 'hooks/profile'
import { useFeatureFlags } from 'hooks/featureFlags'

// Who can see the admin Content Library (sidebar item + its pages).
//
// Three layers, per product:
//   1. Admins only (never authors/editors/CX).
//   2. Behind the `contentLibraryEnabled` feature flag.
//   3. Super admins with the `canViewContentLibrary` privilege bypass the flag —
//      they see it even when it is off (not every super admin, just that grant).
//
// = isAdmin && (flag on || canViewContentLibrary). Read inside an `observer`
// component so the flag and privilege state stay reactive.
export function useContentLibraryAccess(): boolean {
  const user = useBreakoutUser()
  const { contentLibraryEnabled } = useFeatureFlags()
  return user.isAdmin && (contentLibraryEnabled || user.canViewContentLibrary)
}
